import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HoverZoneInfo, MapHoverService } from '../../services/map-hover.service';

@Component({
  selector: 'app-map-hover-panel',
  templateUrl: './map-hover-panel.component.html',
  styleUrls: ['./map-hover-panel.component.scss'],
})
export class MapHoverPanelComponent implements OnInit, OnDestroy {
  zones: HoverZoneInfo[] = [];
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly hoverService: MapHoverService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Leaflet events fire outside Angular's NgZone, so markForCheck() alone never
    // triggers a render cycle. detectChanges() is safe here because zones$ now only
    // emits when the set of zones actually changes (shape boundary crossings).
    this.hoverService.zones$.pipe(takeUntil(this.destroy$)).subscribe(zones => {
      this.zones = zones;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Number of grid columns: 1 col ≤5 zones, 2 cols ≤10, 3 cols >10. */
  get columnCount(): 1 | 2 | 3 {
    if (this.zones.length > 10) { return 3; }
    if (this.zones.length > 5)  { return 2; }
    return 1;
  }
}
